
export interface UpdatePeriodicBackupOperationResult {
    raftCommandIndex: number;
    taskId: number;
}
